import styles from '@components/components/ProductComponentsLegacy/ProductCardHeader/ProductCardHeader.module.scss';
import React from 'react';
import classNames from 'classnames';
import { Content, Heading } from '@wienenergiegithub/ui-next';

const ProductCardHeaderLegacy = ({
  icon,
  price,
  title,
  tarifweltNeu,
  ariaCardLabel,
  background,
  tarifSubline,
  productColor,
}) => {
  const isReducedHeader = title?.includes('SuperSchnell');
  const hasLightBackground =
    (tarifweltNeu && productColor !== 'default') ||
    title?.toLowerCase().includes('tanke');

  return (
    <div
      className={classNames(
        styles.container,
        styles[background],
        styles[productColor],
        {
          [styles.light]: hasLightBackground,
          [styles.reducedHeader]: isReducedHeader,
        },
      )}
    >
      <div
        className={classNames(styles.header, {
          [styles.light]: hasLightBackground,
        })}
      >
        <Heading
          aria-label={ariaCardLabel}
          as="h2"
          className={styles.heading}
          size="h5"
          tabIndex={0}
        >
          {title}
          {tarifSubline && (
            <Content
              className={classNames(styles.tarifSubline, {
                [styles.light]: hasLightBackground,
              })}
            >
              {tarifSubline}
            </Content>
          )}
        </Heading>
        {icon && <div className={styles.icon}>{icon}</div>}
      </div>
      {price && (
        <div
          className={classNames(styles.priceContainer, {
            [styles.reducedHeader]: isReducedHeader,
          })}
        >
          {price}
        </div>
      )}
    </div>
  );
};

export default ProductCardHeaderLegacy;
